import logo from "../assets/jivi.jpg";
import link from "../assets/Link.png";
import ee from "../assets/Email.png";
import phone from "../assets/Phone.png";


import { Link, useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";

export default function Footer({ }) {
  const navigate = useNavigate();



  const knowMore = [
    { name: "About Us", path: "/about" },
    { name: "Schedule a demo", path: "/schedule-a-demo" },
  ];


  const policies = [
    { name: "Workforce Scheduler", path: "/workforce-scheduler" },
    { name: "Operational Workload Planning", path: "/operational-workload-planning" },
    { name: "Capacity Planning", path: "/capacity-planning" },
    { name: "Employee Self Service", path: "/employee-self-service" },
    { name: "Automated Work Allocation", path: "/automated-work-allocation-assignment" },
    { name: "Time & Attendance", path: "/time-attendance" },
    { name: "Connected Systems", path: "/connected-systems" },


  ];

  const contacts = [
    // { phone: "603-27700-311", country: "Malaysia" },
    { phone: "+601-69692690" }

  ];

  const location = useLocation();



  const isActive = (path) => location.pathname === path;

  return (

    <>

      <footer className="font-['Epilogue'] bg-white border-t border-gray-200 w-full">
        <div className="max-w-[1800px] mx-auto px-6 md:px-10 lg:px-16 py-14 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-12">


          <div className="flex flex-col justify-between">
            <Link to="/">
              <img src={logo} alt="JIVI Solutions" className="w-40 mb-4 cursor-pointer" />
            </Link>
            <p className="text-[15px] font-normal text-gray-600 leading-relaxed mb-6">
              A global leader in the design and implementation of enterprise workforce management software built for complex, dynamic environments.
            </p>

          </div>


          <div className="lg:pl-6">
            <h4 className="text-[15px] font-bold mb-4">Know More</h4>
            {knowMore.map((item, i) => (
              <p
                key={i}
                onClick={() => navigate(item.path)}
                className={`text-[15px] mb-2 cursor-pointer transition-colors ${isActive(item.path)
                  ? "text-blue-600 font-semibold"
                  : "text-gray-600 hover:text-blue-500"
                  }`}
              >
                {item.name}
              </p>
            ))}
          </div>


          <div className="lg:-ml-4">
            <h4 className="text-[15px] font-bold mb-4">Our Products</h4>
            {policies.map((item, i) => (
              <p
                key={i}
                onClick={() => navigate(item.path)}
                className={`text-[15px] mb-2 cursor-pointer transition-colors ${isActive(item.path)
                  ? "text-blue-600 font-semibold"
                  : "text-gray-600 hover:text-blue-500"
                  }`}
              >
                {item.name}
              </p>
            ))}
          </div>


          <div>
            <h4 className="text-[15px] font-bold mb-4">Contact Us</h4>

            <a
              href="mailto:info@mawalog.com"
              className="flex items-center text-[15px] font-normal text-blue-700 mb-3"
            >
              <img src={ee} alt="email" className="w-4 h-4 mr-2" />
              info@jivisolutions.com
            </a>

            <a
              href="https://linkedin.com/company/jiviews"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-[15px] font-normal text-blue-700 mb-3"
            >
              <img src={link} alt="linkedin" className="w-4 h-4 mr-2" />
              linkedin.com/company/jiviews
            </a>

            {contacts.map((c, i) => (
              <p key={i} className="flex items-center text-[15px] font-normal mb-2">
                <img src={phone} alt="phone" className="w-4 h-4 mr-2" />
                <a href={`tel:${c.phone}`} className="text-blue-700 mr-1">
                  {c.phone}
                </a>
              </p>
            ))}
          </div>
        </div>


        <div className="border-t border-gray-200 text-center py-4 text-[15px] font-normal text-gray-700">
          Copyright © 2026. <strong>JIVIEWS</strong>. All Rights Reserved
        </div>
      </footer>
    </>

  );
}
